﻿import { FunctionComponent, useEffect } from "react";
import { Grid, GridItem } from "@chakra-ui/react";
import { TopNav } from "./components/TopNav";
import { LeftNav } from "./components/LeftNav";
import { PageRoutes } from "./pages";
import { Footer } from "@am-tax/fe-core";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { useQueryClient } from "@tanstack/react-query";

// Override the conservative fe-core QueryClient defaults so that navigating
// back to a page always fetches fresh data. Queries that opt into aggressive
// caching (staleTime: Infinity) are unaffected since per-query options win.
function QueryClientDefaults() {
    const queryClient = useQueryClient();
    useEffect(() => {
        queryClient.setDefaultOptions({
            queries: {
                ...queryClient.getDefaultOptions().queries,
                refetchOnMount: true,
                staleTime: 0,
            },
        });
    }, [queryClient]);
    return null;
}

export const ApplicationLayout: FunctionComponent = () => {
    return (
        <>
            <QueryClientDefaults />
            <Grid
                templateAreas={` "leftNav topNav"
                             "leftNav main"
                             "footer footer" `}
                gridTemplateRows={"auto 1fr auto"}
                gridTemplateColumns={"auto 1fr"}
            >
                <GridItem as="header" className="page-header" area="topNav">
                    <TopNav />
                </GridItem>
                <GridItem as="nav" area="leftNav" minHeight="100vh">
                    <LeftNav />
                </GridItem>
                <GridItem as="main" area="main" pt="1.5rem" pb="1.5rem" px="2rem">
                    <ErrorBoundary>
                        <PageRoutes />
                    </ErrorBoundary>
                </GridItem>
                <GridItem as="footer" className="page-footer" area="footer">
                    <Footer />
                </GridItem>
            </Grid>
        </>
    );
};
